export const CONFIG = {
  ENVIROMENT: 'PROD',
  DEV: {
    MAIN_END_POINT: 'http://localhost:3061',
    DOCS_END_POINT: 'http://localhost:3067',
    DOCUMENTATION_END_POINT: 'http://localhost:3077',
    XML_END_POINT: 'http://localhost:3087',
    TP_DRIVE_END_POINT: 'http://localhost:3333',
    TOMTOM_API_KEY: 'nQGLAqGG5BNYgSPyFLCuMX9GbYWfmKkA',
    MAPBOX_API_KEY:
      'pk.eyJ1IjoidmFsZXJpby1maWxob3RlIiwiYSI6ImNtM25iZXAwODByYXEydm9zNTh5eXJsb2sifQ.WA5qpGWbc4w9fytxXhz7IQ',
    GCP_API_KEY: 'AIzaSyBJD6AdGgrcGl4F8i4H1y-2Q-4S6yjfhgQ',
    ENABLE_SOCKET: false,
  },
  PROD: {
    MAIN_END_POINT: 'https://api2.tpmanager.net',
    DOCS_END_POINT: 'https://doc3.tpmanager.net',
    TP_DRIVE_END_POINT: 'https://drive.tpmanager.net',
    TOMTOM_API_KEY: 'mXAbGkHTOAOuYykXYayCrk7O2Gp0Cigr',
    DOCUMENTATION_END_POINT: 'https://doc.tpmanager.net',
    XML_END_POINT: 'https://xml.tpmanager.net',
    MAPBOX_API_KEY:
      'pk.eyJ1IjoidmFsZXJpby1maWxob3RlIiwiYSI6ImNtM25iZXAwODByYXEydm9zNTh5eXJsb2sifQ.WA5qpGWbc4w9fytxXhz7IQ',
    GCP_API_KEY: 'AIzaSyBJD6AdGgrcGl4F8i4H1y-2Q-4S6yjfhgQ',
    ENABLE_SOCKET: true,
  },
}
